import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const retrieveTags = (state: RootState) => state.pages.editor.scene.tags;

const getTags = createSelector([retrieveTags], (tags) => tags);

export default getTags;
